<ion-content>

  <!-- Vendor dashbaord -->

  <ion-router-outlet></ion-router-outlet>

</ion-content>
